
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetoadlabsimagicacab() {



    const cardData =
    {
        keyword: 'Pune to Adlabs Imagica Taxi Services',
        heading: 'S9 Travels: Pune to Adlabs Imagica Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Adlabs Imagica. Whether you are planning a fun day out with family, friends, or colleagues, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Adlabs Imagica is approximately 90 km from Pune, and the journey takes around 2 to 2.5 hours by road. Enjoy a safe, comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Attractions at Adlabs Imagica with S9 Travels',

        "topPlaces": [
            {
              "title": "Imagica Theme Park",
              "description": "Imagica Theme Park is the main attraction of Adlabs Imagica, offering a variety of thrilling rides, from roller coasters to water rides, making it an exciting experience for both adults and children. The park is divided into different zones, each offering unique experiences for all ages, including 'The Magic of Movies' and 'The Wild West.'"
            },
            {
              "title": "Imagica Water Park",
              "description": "For a fun-filled day, Imagica Water Park is perfect for water lovers. Featuring numerous water slides, wave pools, and lazy rivers, it offers the ultimate escape to beat the heat. The park caters to people of all age groups with its variety of attractions, from relaxing to adrenaline-pumping rides."
            },
            {
              "title": "Snow Park",
              "description": "Imagica Snow Park offers a cool experience in the middle of the Maharashtra heat. Visitors can enjoy snow-themed activities like snowball fights, ice sculptures, and even a snow slide. It’s an ideal spot to chill and experience snow without having to travel to the mountains."
            },
            {
              "title": "Mr. India – The Ride",
              "description": "One of the most popular attractions at Imagica, Mr. India – The Ride, is a thrilling, immersive experience based on the famous Bollywood film. It combines 3D effects, motion simulation, and incredible visuals to take you on a journey of action and adventure."
            },
            {
              "title": "D2 – The Dance of Destiny",
              "description": "A beautiful dance performance with stunning visuals, D2 takes you through a captivating journey of Indian culture and tradition. The show uses special effects, lighting, and dance to deliver an unforgettable experience for visitors."
            },
            {
              "title": "Boulder Beach",
              "description": "Boulder Beach is a part of the Imagica Water Park and features an array of water slides that are perfect for thrill-seekers. From twisting slides to open rides, Boulder Beach offers non-stop fun and excitement."
            },
            {
              "title": "The Rajasaurus River Adventure",
              "description": "This unique boat ride takes you on a journey through the land of the mighty Rajasaurus, where you encounter thrilling twists and turns, and breathtaking views. It is a family-friendly adventure suitable for all ages."
            },
            {
              "title": "Alibaba aur Chalis Chor",
              "description": "Alibaba aur Chalis Chor is a thrilling ride that immerses you in the world of a legendary adventure. It brings the stories of Alibaba and the Forty Thieves to life with magical effects and adventurous twists. It’s perfect for both kids and adults looking for a lighthearted and fun experience."
            },
            {
              "title": "The Magic of Movies",
              "description": "A must-see attraction, this section of the park brings to life the magic of movies, combining incredible visuals, special effects, and storytelling. The ride takes you through some of the most iconic cinematic moments and leaves you awestruck."
            },
            {
              "title": "Imagica's Shopping and Dining",
              "description": "After a fun-filled day at the park, visitors can explore the shopping areas for souvenirs, as well as enjoy a range of dining options offering everything from local delights to international cuisines. Whether you’re in the mood for a quick bite or a full meal, Imagica has something to satisfy every palate."
            }
          ],

"services": [
  {
    "name": "Pune to Adlabs Imagica Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Adlabs Imagica. Whether you’re visiting the theme park for a fun day or a weekend getaway, enjoy a smooth and hassle-free ride. Book your Pune to Adlabs Imagica taxi today!"
  },
  {
    "name": "Pune to Adlabs Imagica Cab Booking",
    "description": "Booking a cab from Pune to Adlabs Imagica is easy with S9 Travels. Whether you prefer booking online or by phone, we provide flexible booking options to ensure a smooth and convenient trip. Book your ride today!"
  },
  {
    "name": "Pune to Adlabs Imagica One-Way Taxi",
    "description": "S9 Travels provides affordable and convenient one-way taxi services from Pune to Adlabs Imagica. Travel directly to the park with comfort and ease. Book your one-way taxi now for a hassle-free and enjoyable journey."
  },
  {
    "name": "Pune to Adlabs Imagica Round Trip",
    "description": "For a round trip from Pune to Adlabs Imagica, S9 Travels offers flexible and reliable options. We ensure that your journey is stress-free, timely, and comfortable, with professional drivers to make your round trip enjoyable."
  },
  {
    "name": "Pune to Adlabs Imagica Cab Service",
    "description": "Choose S9 Travels for a professional and dependable cab service from Pune to Adlabs Imagica. Our experienced drivers and well-maintained vehicles ensure a comfortable, safe, and enjoyable journey, giving you more time to enjoy the park."
  },
  {
    "name": "Pune to Adlabs Imagica Taxi Fare",
    "description": "S9 Travels provides transparent and competitive taxi fares for your Pune to Adlabs Imagica trip. We ensure great value for your money, with no hidden charges. Contact us for an accurate fare estimate before booking."
  },
  {
    "name": "Pune to Adlabs Imagica Car Rental",
    "description": "Looking for a car rental for your trip from Pune to Adlabs Imagica? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles that suit your preferences and needs."
  }
],


"tableData": [
  ["Book Pune To Adlabs Imagica Taxi", "Book Pune To Adlabs Imagica Cab Booking"],
  ["Book Pune To Adlabs Imagica One-Way Taxi", "Book Pune To Adlabs Imagica Round Trip"],
  ["Book Pune To Adlabs Imagica Cab Service", "Book Pune To Adlabs Imagica Taxi Fare"],
  ["Book Pune To Adlabs Imagica Car Rental", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how exciting your visit to Adlabs Imagica can be. Whether you're planning a fun-filled family day or a trip with friends, we ensure on-time pickups and drop-offs so you can make the most of your time at the park."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a fleet of comfortable and spacious vehicles for your journey to Adlabs Imagica. Our vehicles are equipped with air conditioning, comfortable seating, and ample space for your luggage, ensuring a pleasant and relaxing ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced in long-distance travel and know the best routes to Adlabs Imagica. They are dedicated to providing safe, smooth, and professional service, ensuring that your trip is both enjoyable and secure."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Pune to Adlabs Imagica trip. We provide a clear breakdown of costs upfront, with no hidden charges, so you can travel with confidence knowing exactly what to expect."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features, such as airbags, seat belts, and GPS tracking, ensuring a safe and comfortable journey from Pune to Adlabs Imagica."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates around the clock, so whether you’re planning an early morning trip or a late-night return from Imagica, we are always ready to accommodate your schedule. Our customer service team is also available at all hours to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Adlabs Imagica cab with S9 Travels is quick and simple. You can book online via our website or app, or reach out to our customer service team for assistance with your reservation."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you’re visiting Adlabs Imagica for a family outing, a corporate event, or a fun weekend, we offer customized travel packages to meet your needs. Let us know your preferences, and we’ll tailor the trip to make it memorable and special."
  }
]

















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Adlabs Imagica cab with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or contact our customer service team for personalized assistance with your reservation.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are experienced in long-distance travel and are familiar with the best routes to Adlabs Imagica, ensuring a smooth and safe journey.',
          },
          {
            question: 'What types of vehicles are available for Pune to Adlabs Imagica travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, all well-maintained and designed for comfort and safety during your trip to Adlabs Imagica.',
          },
          {
            question: 'How do I pay for my Pune to Adlabs Imagica cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, providing a hassle-free payment experience.',
          },
          {
            question: 'Can I book a round trip from Pune to Adlabs Imagica?',
            answer: 'Yes, we offer round-trip services. Simply provide your return details, and we will make all the necessary arrangements for a seamless return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as for waiting time or detours, will be clearly communicated to you upfront, ensuring transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing at Adlabs Imagica?',
            answer: 'While Adlabs Imagica is an amusement park, we are happy to accommodate sightseeing tours around the area or provide transportation to nearby attractions before or after your visit to the park.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Adlabs Imagica cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Adlabs Imagica?',
            answer: 'Yes, we offer corporate travel services for team outings or business events at Adlabs Imagica. We ensure punctual and professional service for corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Adlabs Imagica travel?',
            answer: 'S9 Travels ensures a comfortable, reliable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We guarantee a stress-free and enjoyable trip to Adlabs Imagica every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sameer Shah',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip to Adlabs Imagica was fantastic, thanks to S9 Travels! The driver was punctual, and the vehicle was clean and comfortable. It made our trip much more enjoyable. Highly recommended!”',
        },
        {
          name: 'Mrs. Neha Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We had a great experience traveling with S9 Travels to Adlabs Imagica. The driver was friendly and knew the best routes to avoid traffic. The car was spacious and comfortable for our family of four.”',
        },
      ];
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Adlabs Imagica Cab",
        "description": "Book Pune To Adlabs Imagica taxi services, one-way taxi, round trip, car rental, and more with S9 Travels. Choose from affordable Pune to Adlabs Imagica cab booking options for a fun and comfortable trip to the amusement park.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      
      


    return (
        <div>
         <Helmet>
        <title>Book Pune To Adlabs Imagica Cab | Affordable Taxi & Car Rental Services | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Adlabs Imagica taxi services, one-way taxi, round trip, car rental, and more with S9 Travels. Get the best fares for Pune to Adlabs Imagica cab booking and enjoy a comfortable and safe ride to the amusement park." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/12.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetoadlabsimagicacab;